import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BuyNowService } from '../services/buy-now.service';
import { ColCatService } from '../../shop/services/col-cat.service';
import { LocalStorageService } from '../services/local-storage.service';
import { NavService } from '../../shop/services/nav.service';
import { Subscription } from 'rxjs';
import { FirestoreRange } from '../interfaces/firestore-range';
import swal from 'sweetalert2';
import { ToggleMenuService } from '../../shop/services/toggle-menu.service';
import { TransformTextService } from '../services/transform-text.service';

@Component({
  selector: 'app-subscription-menu',
  templateUrl: './subscription-menu.component.html',
  styleUrls: ['./subscription-menu.component.scss']
})

export class SubscriptionMenuComponent implements AfterViewInit, OnDestroy, OnInit {

  private collections: any[];
  private categories: any[];
  private categoryNames: string[];
  private evalMonth: boolean;
  private monthLength: number;
  private monthVal: string[];
  private products: FirestoreRange[];

  public area: string;
  public areaState: boolean;
  public areaVal: string;
  public buyState: boolean;
  public months: string;
  public status = false;
  public subscription: Subscription;

  constructor(
    private buyNow: BuyNowService,
    private colCatService: ColCatService,
    // private config: NgbCarouselConfig,
    // private int: IntegerService,
    // private fsProducts: FirestoreProductsService,
    private navState: NavService,
    // private router: Router,
    private titleCaseService: TransformTextService,
    private toggleMenuService: ToggleMenuService,

    public ls: LocalStorageService
  ) {
    // this.ls.areaObs.next('gauteng');
    this.ls.areaWrite('gauteng');

    this.buyState = false;
    this.areaState = false;

    this.subscription =
      this.toggleMenuService.statusChange.subscribe(status => this.status = status),
      this.buyNow.getStatus().subscribe(status => this.buyState = status),
      this.ls.areaReturn().subscribe(area => this.areaState = area),
      this.colCatService.getCollections().subscribe(data => this.collections = data);
  }

  ngAfterViewInit() {
    this.initLsValues();
  }

  ngOnInit() {
    this.subcribeArea();
    this.subcribeMonth();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subcribeArea();
    this.subcribeMonth();
  }

  public buyProduct(set: boolean): void {
    this.buyNow.setBuy(set);
  }

  private clearCol(): void {
    const otherCol = document.getElementsByClassName('collection-sub');
    for (let i = 0; i < otherCol.length; i++) {
      otherCol[i].classList.remove('selected');
    }
  }

  public clearLocal(): void {
    const otherLocal = document.getElementsByClassName('location');
    for (let i = 0; i < otherLocal.length; i++) {
      otherLocal[i].classList.remove('selected');
    }
  }

  public clearMonth(): void {
    const otherMonths = document.getElementsByClassName('month');
    for (let i = 0; i < otherMonths.length; i++) {
      otherMonths[i].classList.remove('selected');
    }
  }

  private colSelect(event): void {
    const elemId = event.srcElement.id;
    console.log(event);
    event.srcElement.classList.add('selected');
    // document.getElementById(elemId).classList.add('selected');
    this.toggleMenuService.changeStatus(false);
  }

  public getArea(event): void {
    const areaList: string[] = [
      'gauteng',
      'cape-town',
      'durban',
      'other'
    ];

    const monthClass = document.getElementsByClassName('month');
    const monthSelection: string = localStorage.getItem('monthSelection');
    const getArea: string = event.srcElement.id;
    event.srcElement.classList.add('selected');
    this.sendArea(getArea);
    this.ls.areaSend(true);

    if (getArea === areaList[1] || getArea === areaList[2] || getArea === areaList[3]) {
      this.ls.monthObs.next('0');
    } else if (this.area === areaList[0]) {
      for (let i = 0; i < monthClass.length; i++) {
        if (monthClass[i].classList.contains('selected')) {
          monthClass[i].classList.remove('selected');
        }
      }
    }

    if (monthSelection) {
      this.ls.removeMonth();
    }
  }

  private getKeys(obj): any {
    return Object.keys(obj);
  }

  public getMonth(event): void {
    const getMonth: string = event.srcElement.id;
    event.srcElement.classList.add('selected');
    this.evalMonth = !this.evalMonth;
    this.sendMonth(getMonth);

    const prodPrices = localStorage.getItem('productsPrice');
    if (localStorage.getItem('productsPrice')) {
      this.ls.priceWrite(prodPrices);
    }
  }

  private getTitleCase(string: string): string {
    return this.titleCaseService.newName(string);
  }

  private initLsValues(): void {
    const months = localStorage.getItem('monthSelection');
    const area = localStorage.getItem('areaSelection');

    if (months !== null || months !== undefined) {
      this.months = months;
      this.setMonth(this.months);
    }

    if (area) {
      this.area = area;
      this.setArea(this.area);
      this.ls.areaSend(true);
    }
  }

  public next(): void {
    const area = this.area;
    const month = this.months;

    if ( (area !== null && area !== undefined) && (month !== null && month !== undefined) ) {
      this.toggleMenuService.changeStatus(false);
      this.navState.openNav(true);
    } else {
      swal.fire({
        confirmButtonText: 'Ok',
        imageAlt: 'Landmarq Road',
        imageUrl: '/assets/img/landmarq-road.svg',
        title: 'Please note!',
        text: 'Kindly make your selections first.',
        type: 'error'
      });
    }
  }

  private selectSubscription(): void {
    const subscriptionList = document.querySelectorAll('.subscription-list li');
    const first = document.getElementsByClassName('first');

    for (let i = 0; i < subscriptionList.length; i++) {
      if (subscriptionList[i].classList.contains('first')) {
        subscriptionList[i].classList.remove('selected');
        first[0].classList.add('selected');
        break;
      }
    }
  }

  private sendArea(area: string): void {
    this.ls.areaWrite(area);
  }

  private sendMonth(month: string): void {
    this.ls.monthWrite(month);
  }

  private setArea(area: string): void {
    const setArea = <HTMLBodyElement>document.getElementById(area);
    if (setArea) {
      setArea.classList.add('selected');
    } else {
      console.log('Couldn\'t find ID with value of ' + area);
    }
  }

  private setMonth(month: string): void {
    console.log(month + typeof month);
    const setMonth = <HTMLBodyElement>document.getElementById(month);
    if (setMonth) {
      setMonth.classList.add('selected');
    } else {
      console.log('Couldn\'t find ID with value of ' + month);
    }
  }

  public subcribeArea(): void {
    this.subscription = this.ls.areaListener().subscribe(area => {
      if (area) {
        this.area = area;
        // this.areaVal = Object.values(area);
      }
   });
  }

  public subcribeMonth(): void {
    this.subscription = this.ls.monthListener().subscribe(month => {
      if (month) {
        console.log('month: ' + month + ', type: ' + typeof month);
        this.months = month;
      } else {
        this.months = null;
      }
   });
  }

  public subOff(): void {
    this.toggleMenuService.changeStatus(false);
  }

  public subOn(): void {
    this.toggleMenuService.changeStatus(true);
  }
}
